// appConfigFields.js
const appConfigFields = {
  NoOp: [
    {
      name: "label",
      label: "Label",
      type: "text",
      defaultValue: "Inbound Call",
      helperText: "Label for the application",
    },
  ],
  Dial: [
    {
      name: "destination",
      label: "Destination Number",
      type: "text",
      defaultValue: "",
      required: true,
      helperText: "Enter the number to dial (e.g., SIP/1234 or PJSIP/1234)",
    },
    {
      name: "timeout",
      label: "Ring Timeout",
      type: "number",
      defaultValue: "30",
      required: true,
      helperText: "Ring timeout in seconds",
    },
    {
      name: "options",
      label: "Dial Options",
      type: "text",
      defaultValue: "tT",
      helperText: "Dial options (e.g., tT for transfer)",
    },
    {
      name: "callerId",
      label: "Caller ID",
      type: "text",
      defaultValue: "",
      helperText: "Optional: Override caller ID",
    },
    {
      name: "musicOnHold",
      label: "Music On Hold Class",
      type: "text",
      defaultValue: "default",
      helperText: "Music on hold class to use while dialing",
    },
    {
      name: "confirmCall",
      label: "Confirm Call",
      type: "checkbox",
      defaultValue: false,
      helperText: "Require called party to press 1 to accept the call",
    },
    {
      name: "recordCall",
      label: "Record Call",
      type: "checkbox",
      defaultValue: false,
      helperText: "Record the call after answer",
    },
  ],
  InternalDial: [
    {
      name: "internalExtension",
      label: "Internal Extension",
      type: "select",
      required: true,
      helperText: "Select an agent's extension",
      defaultValue: "",
    },
    {
      name: "timeout",
      label: "Timeout (seconds)",
      type: "number",
      required: false,
      helperText: "Ring timeout in seconds",
      defaultValue: "30",
    },
    {
      name: "url",
      label: "URL",
      type: "text",
      required: false,
      helperText: "URL to be called when the call is answered",
      defaultValue: "",
    },
    {
      name: "options",
      label: "Options",
      type: "text",
      required: false,
      helperText: "Additional options for the dial command",
      defaultValue: "xX",
    },
    {
      name: "enableRecording",
      label: "Enable Recording",
      type: "checkbox",
      required: false,
      helperText: "Enable call recording",
      defaultValue: false,
    },
    {
      name: "enableCallerId",
      label: "Enable Caller ID",
      type: "checkbox",
      required: false,
      helperText: "Enable caller ID",
      defaultValue: true,
    },
  ],
  ExternalDial: [
    {
      name: "number",
      label: "External Number",
      type: "text",
      defaultValue: "",
      required: true,
      helperText: "Enter the external phone number",
    },
    {
      name: "timeout",
      label: "Ring Timeout",
      type: "number",
      defaultValue: "30",
      required: true,
      helperText: "Ring timeout in seconds",
    },
    {
      name: "trunk",
      label: "Outbound Trunk",
      type: "select",
      options: [
        { value: "voip-provider", label: "VoIP Provider" },
        { value: "pstn", label: "PSTN" },
        { value: "sip-trunk", label: "SIP Trunk" },
      ],
      defaultValue: "voip-provider",
      required: true,
    },
  ],
  ringGroup: [
    {
      name: "user",
      label: "User",
      type: "select",
      options: [],
      defaultValue: "",
      required: true,
    },
    {
      name: "timeout",
      label: "Timeout",
      type: "number",
      defaultValue: 30,
    },
    {
      name: "options",
      label: "Options",
      type: "text",
      defaultValue: "xX",
    },
    {
      name: "url",
      label: "URL",
      type: "text",
      defaultValue: "",
    },
  ],
  Playback: [
    {
      name: "context",
      label: "Context",
      type: "text",
      defaultValue: "from-voip-provider",
      required: true,
      hidden: true,
    },
    {
      name: "exten",
      label: "Extension / Phone Number",
      type: "text",
      required: true,
      hidden: true,
    },
    {
      name: "priority",
      label: "Priority",
      type: "number",
      defaultValue: 13,
      required: true,
      helperText: "Dialplan priority for this application",
    },
    {
      name: "app",
      label: "Application",
      type: "text",
      defaultValue: "Playback",
      required: true,
      hidden: true,
    },
    {
      name: "answer",
      label: "Answer Call",
      type: "checkbox",
      defaultValue: true,
      required: true,
      helperText: "Answer the call before playing audio (recommended)",
    },
    {
      name: "audioFiles",
      label: "Audio Files",
      type: "select",
      // options: [],
      defaultValue: "",
      required: true,
      helperText: "Select audio file to play",
    },
    {
      name: "skipMs",
      label: "Skip (ms)",
      type: "number",
      defaultValue: 0,
      required: false,
      helperText: "Skip first N milliseconds of the audio",
    },
    {
      name: "noanswer",
      label: "No Answer",
      type: "checkbox",
      defaultValue: false,
      helperText: "Don't answer channel before playback",
    },
    {
      name: "synchronous",
      label: "Synchronous",
      type: "checkbox",
      defaultValue: true,
      helperText: "Wait for playback to complete before continuing",
    },
    {
      name: "channel",
      label: "Channel",
      type: "text",
      defaultValue: "",
      helperText: "Optional: Specific channel to play audio on",
    },
    {
      name: "type",
      label: "Type",
      type: "text",
      defaultValue: "inbound",
      required: true,
      hidden: true,
    },
    {
      name: "tag",
      label: "Tag",
      type: "text",
      defaultValue: "playback",
      required: true,
      hidden: true,
    },
  ],
  Queue: [
    {
      name: "queue",
      label: "Queue Name",
      type: "select",
      required: true,
      defaultValue: "",
      helperText: "Select a voice queue",
    },
    {
      name: "answerBeforeQueue",
      label: "Answer Before Queue",
      type: "checkbox",
      defaultValue: false,
      helperText:
        "When OFF (recommended), the call is NOT answered before entering the queue — the caller hears ringing but is NOT billed until an agent picks up. When ON, the call is answered immediately (caller may be billed during queue wait).",
    },
    {
      name: "options",
      label: "Options",
      type: "text",
      defaultValue: "rn",
      helperText:
        "Select queue options. 'r' for ring and 'n' for hangup detection are recommended.",
    },
    {
      name: "url",
      label: "URL",
      type: "text",
      defaultValue: "",
    },
    {
      name: "announceOverrides",
      label: "Announce Overrides",
      type: "select",
      options: [
        { value: "", label: "None" },
        { value: "agent_action_failure", label: "Agent Action Failure" },
        { value: "agent_end_pause", label: "Agent End Pause" },
        { value: "agent_login", label: "Agent Login" },
        { value: "agent_menu", label: "Agent Menu" },
        { value: "agent_pause", label: "Agent Pause" },
        { value: "call_rating_message", label: "Call Rating Message" },
        { value: "order_elaborated", label: "Order Elaborated" },
        { value: "order_message", label: "Order Message" },
        { value: "order_shipped", label: "Order Shipped" },
        { value: "thank_you", label: "Thank you" },
        { value: "welcome_message", label: "Welcome Message" },
      ],
      defaultValue: "",
    },
    {
      name: "timeout",
      label: "Timeout",
      type: "number",
      defaultValue: 30,
    },
    {
      name: "agi",
      label: "Agi",
      type: "text",
      defaultValue: "",
    },
    {
      name: "macro",
      label: "Macro",
      type: "text",
      defaultValue: "",
    },
    {
      name: "goSub",
      label: "GoSub",
      type: "text",
      defaultValue: "",
    },
    {
      name: "rule",
      label: "Rule",
      type: "text",
      defaultValue: "",
    },
    {
      name: "position",
      label: "Position",
      type: "checkbox",
      defaultValue: false,
    },
  ],
  Set: [
    {
      name: "variable",
      label: "Variable",
      type: "select",
      options: [
        { value: "CALLERID(dnid)", label: "CALLERID(dnid)" },
        { value: "CALLERID(name)", label: "CALLERID(name)" },
        { value: "CALLERID(num)", label: "CALLERID(num)" },
        { value: "CHANNEL(language)", label: "CHANNEL(language)" },
        { value: "CHOICE", label: "CHOICE" },
        { value: "COUNTER", label: "COUNTER" },
        { value: "DBRESULT", label: "DBRESULT" },
        { value: "EMAIL", label: "EMAIL" },
        { value: "EXTRAVAR", label: "EXTRAVAR" },
        { value: "FIRSTNAME", label: "FIRSTNAME" },
        { value: "INPUT", label: "INPUT" },
        { value: "LASTNAME", label: "LASTNAME" },
        { value: "OPTION", label: "OPTION" },
        { value: "ORDER", label: "ORDER" },
        { value: "ORDERNUM", label: "ORDERNUM" },
        { value: "PHONE", label: "PHONE" },
        { value: "RATE", label: "RATE" },
        { value: "RESULT", label: "RESULT" },
        { value: "UNIQUEID", label: "UNIQUEID" },
        { value: "VAR1", label: "VAR1" },
        { value: "VAR2", label: "VAR2" },
        { value: "VAR3", label: "VAR3" },
      ],
      defaultValue: "",
      required: true,
    },
    {
      name: "value",
      label: "Value",
      type: "text",
      defaultValue: "",
      required: true,
    },
  ],
  GoTo: [
    {
      name: "context",
      label: "Context",
      type: "select",
      options: [
        { value: "from-sip", label: "from-sip" },
        { value: "from-voip-provider", label: "from-voip-provider" },
        {
          value: "mayday-mixmonitor-context",
          label: "mayday-mixmonitor-context",
        },
      ],
      defaultValue: "from-sip",
    },
    {
      name: "extension",
      label: "Extension",
      type: "text",
      defaultValue: "",
      required: true,
    },
    {
      name: "priority",
      label: "Priority",
      type: "number",
      defaultValue: 1,
      required: true,
    },
  ],
  Hangup: [
    {
      name: "hangupCause",
      label: "Hangup Cause",
      type: "select",
      options: [
        { value: "1", label: "1 = Unallocated number" },
        { value: "16", label: "16 = Call Restricted" },
        { value: "17", label: "17 = User busy" },
        { value: "18", label: "18 = No user responding" },
        { value: "19", label: "19 = No answer" },
        { value: "21", label: "21 = Call rejected" },
        { value: "22", label: "22 = Number changed" },
        { value: "27", label: "27 = Destination out of order" },
        { value: "28", label: "28 = Invalid number format" },
        { value: "38", label: "38 = Network out of order" },
        { value: "41", label: "41 = Temporary failure" },
        { value: "42", label: "42 = Network congestion" },
        { value: "44", label: "44 = Requested channel not available" },
        { value: "58", label: "58 = Bearer capability not available" },
        { value: "65", label: "65 = Bearer capability not implemented" },
      ],
      defaultValue: "19", // Default to 'No answer'
      required: true,
    },
  ],
  SendDTMF: [
    {
      name: "dtmfDigits",
      label: "DTMF digits",
      type: "text",
      helperText:
        "Example 0123456789ABCDabcd*# w = pause 1/2 second, W = pause 1 second, f = flash hook",
      defaultValue: "",
      required: true,
    },
    {
      name: "timeoutBetweenTones",
      label: "Timeout between tones (ms)",
      type: "number",
      defaultValue: 25,
      validation: {
        min: 25,
      },
      required: true,
    },
    {
      name: "toneDuration",
      label: "Tone duration (ms)",
      type: "number",
      defaultValue: "",
      validation: {
        min: 25,
      },
      required: true,
    },
  ],
  Custom: [
    {
      name: "applicationName",
      label: "Application Name",
      type: "text",
      defaultValue: "",
      required: true,
    },
    {
      name: "arguments",
      label: "Arguments",
      type: "text",
      defaultValue: "",
    },
  ],
  IVR: [
    {
      name: "flowId",
      label: "IVR Flow",
      type: "select",
      required: true,
      helperText: "Select an IVR flow",
      defaultValue: "",
    },
  ],
};

export default appConfigFields;
